// extracted by mini-css-extract-plugin
module.exports = {"Link":"Links_Link___4lsG"};